import axios, { AxiosInstance } from 'axios';

const apiRoutes: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_ROUTES_URL,
    headers: {
        'Content-type': 'application/json',
    },
});

export default apiRoutes;